import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatDate(date) {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function getDaysUntil(date) {
  const diff = new Date(date) - new Date();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

export function getCompetitivenessColor(score) {
  if (!score) return 'gray';
  if (score >= 90) return 'green';
  if (score >= 70) return 'blue';
  if (score >= 50) return 'yellow';
  if (score >= 30) return 'orange';
  return 'red';
}

export function getCompetitivenessLabel(score) {
  if (!score) return 'Unknown';
  if (score >= 90) return 'Highly Competitive';
  if (score >= 70) return 'Competitive';
  if (score >= 50) return 'At Market';
  if (score >= 30) return 'Below Market';
  return 'At Risk';
}

export function getStatusColor(status) {
  const colors = {
    ACTIVE: 'green',
    PENDING_RENEWAL: 'yellow',
    EXPIRED: 'red',
    TERMINATED: 'gray',
  };
  return colors[status] || 'gray';
}

export function getCustomerStatusColor(status) {
  const colors = {
    VIP: 'purple',
    STRATEGIC: 'blue',
    STANDARD: 'gray',
    SMB: 'slate',
  };
  return colors[status] || 'gray';
}
